import React from 'react';
import { useDispatch } from 'react-redux';
import { PhoneValidationModal } from 'components/common/PhoneValidationModal';
import { removePopup, getUserData } from '../../../../redux/actions';
import { generateTestId } from '../../../../app/functions';

const PhoneValidation = ({
    phone,
    userId,
    email,
    ccDigits,
    registrationPayload,
    initialOtpResponse,
    onLogin,
    handleClose,
    process = 'register',
    testID = 'phone-validation'
}) => {
    const dispatch = useDispatch();

    const handleSuccess = () => {
        dispatch(getUserData());
        if (handleClose) {
            handleClose();
        } else {
            dispatch(removePopup());
        }
        if (onLogin) {
            onLogin();
        }
    };

    const handleModalClose = () => {
        if (handleClose) {
            handleClose();
        } else {
            dispatch(removePopup());
        }
    };

    return (
        <PhoneValidationModal
            open={true}
            onClose={handleModalClose}
            phone={phone}
            userId={userId}
            email={email}
            ccDigits={ccDigits}
            registrationPayload={registrationPayload}
            initialOtpResponse={initialOtpResponse}
            onSuccess={handleSuccess}
            process={process}
            testID={generateTestId(testID, 'modal')}
        />
    );
};

export default PhoneValidation;


